var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 48,
    viewBox: "0 0 240 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0L29.3883 16.5836H46.8254L32.7185 26.8328L38.1068 43.4164L24 33.1672L9.89315 43.4164L15.2815 26.8328L1.17464 16.5836H18.6117L24 0Z",
    fill: "#FFD600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 0L77.3883 16.5836H94.8254L80.7185 26.8328L86.1068 43.4164L72 33.1672L57.8932 43.4164L63.2815 26.8328L49.1746 16.5836H66.6117L72 0Z",
    fill: "#FFD600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120 0L125.388 16.5836H142.825L128.719 26.8328L134.107 43.4164L120 33.1672L105.893 43.4164L111.281 26.8328L97.1746 16.5836H114.612L120 0Z",
    fill: "#FFD600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168 0L173.388 16.5836H190.825L176.719 26.8328L182.107 43.4164L168 33.1672L153.893 43.4164L159.281 26.8328L145.175 16.5836H162.612L168 0Z",
    fill: "#FFD600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216 0L221.388 16.5836H238.825L224.719 26.8328L230.107 43.4164L216 33.1672L201.893 43.4164L207.281 26.8328L193.175 16.5836H210.612L216 0Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216 0V16.5836V22V27.5V31V33.1672L201.893 43.4164L207.282 26.8328L193.175 16.5836H210.612L216 0Z",
    fill: "#FFD600"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ac6b785df56894955d7861d9f54e6575.svg";
export { ForwardRef as ReactComponent };